import { render, staticRenderFns } from "./UserGroupAddForm.vue?vue&type=template&id=63ed3f63"
import script from "./UserGroupAddForm.vue?vue&type=script&lang=js"
export * from "./UserGroupAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports